import Deadline from "../../entities/deadline";

/**
 * Deadline actions
 *
 * Call order:
 *
 * DEADLINE_SAVE_QUEUE:	adds the item to the save queue
 * --> DEADLINE_SAVE:	modifies the state
 * --> DEADLINE_SAVE_SUCCESS: if all went well
 * --> DEADLINE_SAVE_FAILURE:	if either the queue or local save failed
 *
 * Note that the only way to fail DEADLINE_SAVE_QUEUE is during the call to DEADLINE_SAVE,
 * as adding an item to the queue should never fail.
 */

export const DEADLINE_FETCH_ONE_QUEUE: any = 'DEADLINE_FETCH_ONE_QUEUE';
export const DEADLINE_FETCH_SUCCESS: any = 'DEADLINE_FETCH_SUCCESS';
export const DEADLINE_FETCH_FAILURE: any = 'DEADLINE_FETCH_FAILURE';
export const DEADLINE_FETCH_ONE_SUCCESS: any = 'DEADLINE_FETCH_ONE_SUCCESS';
export const DEADLINE_FETCH_ONE_FAILURE: any = 'DEADLINE_FETCH_ONE_FAILURE';

export const DEADLINE_SAVE: any = 'DEADLINE_SAVE';
export const DEADLINE_SAVE_QUEUE: any = 'DEADLINE_SAVE_QUEUE';
export const DEADLINE_SAVE_SUCCESS: any = 'DEADLINE_SAVE_SUCCESS';
export const DEADLINE_SAVE_FAILURE: any = 'DEADLINE_SAVE_FAILURE';

export const DEADLINE_SAVE_MANY: any = 'DEADLINE_SAVE_MANY';
export const DEADLINE_SAVE_MANY_QUEUE: any = 'DEADLINE_SAVE_MANY_QUEUE';
export const DEADLINE_SAVE_MANY_SUCCESS: any = 'DEADLINE_SAVE_MANY_SUCCESS';
export const DEADLINE_SAVE_MANY_FAILURE: any = 'DEADLINE_SAVE_MANY_FAILURE';

export const DEADLINE_REMOVE: any = 'DEADLINE_REMOVE';
export const DEADLINE_REMOVE_QUEUE: any = 'DEADLINE_REMOVE_QUEUE';
export const DEADLINE_REMOVE_SUCCESS: any = 'DEADLINE_REMOVE_SUCCESS';
export const DEADLINE_REMOVE_FAILURE: any = 'DEADLINE_REMOVE_FAILURE';

export const DEADLINE_RESTORE: any = 'DEADLINE_RESTORE';
export const DEADLINE_RESTORE_QUEUE: any = 'DEADLINE_RESTORE_QUEUE';
export const DEADLINE_RESTORE_SUCCESS: any = 'DEADLINE_RESTORE_SUCCESS';
export const DEADLINE_RESTORE_FAILURE: any = 'DEADLINE_RESTORE_FAILURE';

export const DEADLINE_RESTORE_MANY: any = 'DEADLINE_RESTORE_MANY';
export const DEADLINE_REMOVE_MANY: any = 'DEADLINE_REMOVE_MANY';

/* Fetch actions */
export const fetchDeadlineSuccess = (deadlines: Deadline[], partial: boolean, lastFetch: number) => ({type: DEADLINE_FETCH_SUCCESS, deadlines, partial, lastFetch});
export const fetchDeadlineFailure = (err: any) => {
		console.error('DeadlineAction: fetchDeadlineFailure', err);
		return {type: DEADLINE_FETCH_FAILURE, err};
};
export const fetchOneDeadlineQueue = (deadlineId: string) => ({type: DEADLINE_FETCH_ONE_QUEUE, deadlineId});
export const fetchOneDeadlineSuccess = (deadline: Deadline) => ({type: DEADLINE_FETCH_ONE_SUCCESS, deadline});
export const fetchOneDeadlineFailure = (id: string, err: any) => {
		console.error('DeadlineAction: fetchOneDeadlineFailure', err);
		return {type: DEADLINE_FETCH_ONE_FAILURE, id, err};
};

/* Save actions */
export const saveDeadline = (deadline: Deadline) => {
    // console.debug('⮂ DEADLINE_SAVE action', deadline?.id);
    return {type: DEADLINE_SAVE, deadline};
}
export const saveDeadlineQueue = (deadline: Deadline) => {
    // console.debug('⮂ DEADLINE_SAVE_QUEUE action', deadline?.id);
    return {type: DEADLINE_SAVE_QUEUE, deadline};
}
export const saveDeadlineSuccess = (deadline: Deadline) => {
    // console.debug('⮂ DEADLINE_SAVE_SUCCESS action', deadline?.id);
    return {type: DEADLINE_SAVE_SUCCESS, deadline};
}
export const saveDeadlineFailure = (deadline: Deadline, status: number, message: string) => {
    console.warn(`⮂ DEADLINE_SAVE_FAILURE error saving deadline: HTTP ${status}: ${message}`, deadline?.id);
    return {type: DEADLINE_SAVE_FAILURE, deadline, status, message};
};

/* SaveMany actions */
export const saveManyDeadlines = (deadlines: Deadline[]) => {
    // console.debug('⮂ DEADLINE_SAVE_MANY action', deadlines?.map(deadline => deadline?.id).join(','));
    return {type: DEADLINE_SAVE_MANY, deadlines};
}
export const saveManyDeadlinesQueue = (deadlines: Deadline[]) => {
    // console.debug('⮂ DEADLINE_SAVE_MANY_QUEUE action', deadlines?.map(deadline => deadline.id).join(','));
    return {type: DEADLINE_SAVE_MANY_QUEUE, deadlines};
}

export const saveManyDeadlinesSuccess = (deadlines: Deadline[]) => {
    // console.debug('⮂ DEADLINE_SAVE_MANY_SUCCESS action', deadlines?.map(deadline => deadline.id).join(','));
    return {type: DEADLINE_SAVE_MANY_SUCCESS, deadlines};
}
export const saveManyDeadlinesFailure = (deadlines: Deadline[], status: number, message: string) => {
		console.warn(`⮂ SAVE_MANY_DEADLINES_FAILURE Error saving deadlines: HTTP ${status}: ${message}`, deadlines?.map(deadline => deadline.id).join(','));
		return {type: DEADLINE_SAVE_MANY_FAILURE, deadlines, status, message};
};

/* Remove actions */
export const removeDeadline = (deadline: Deadline) => ({ type: DEADLINE_REMOVE, deadline });
export const removeDeadlineQueue = (deadline: Deadline) => ({ type: DEADLINE_REMOVE_QUEUE, deadline });
export const removeDeadlineSuccess = (deadline: Deadline) => ({ type: DEADLINE_REMOVE_SUCCESS, deadline });
export const removeDeadlineFailure = (deadline: Deadline, status: number, message: string) => {
	console.error(`Redux: removeDeadlineFailure Error removing deadline: HTTP ${status}: ${message}`);
	return ({ type: DEADLINE_REMOVE_FAILURE, deadline, status, message });
};

/* Restore actions */
export const restoreDeadline = (deadline: Deadline) => ({ type: DEADLINE_RESTORE, deadline });
export const restoreDeadlineQueue = (deadline: Deadline) => ({ type: DEADLINE_RESTORE_QUEUE, deadline });
export const restoreDeadlineSuccess = (deadline: Deadline) => ({ type: DEADLINE_RESTORE_SUCCESS, deadline });
export const restoreDeadlineFailure = (deadline: Deadline, status: number, message: string) => {
	console.error(`Redux: restoreDeadlineFailure Error restoring deadline: HTTP ${status}: ${message}`);
	return ({ type: DEADLINE_RESTORE_FAILURE, deadline, status, message });
};

/* RestoreMany actions */
export const restoreManyDeadlines = (deadlines: Deadline[]) => ({ type: DEADLINE_RESTORE_MANY, deadlines });

/* RemoveMany actions */
export const removeManyDeadlines = (deadlines: Deadline[]) => ({ type: DEADLINE_REMOVE_MANY, deadlines });